'use strict';

if (!customElements.get('luvano-review-carousel')) {
  customElements.define('luvano-review-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.lvAbort) return;
      const track = this.querySelector('[data-lv-review-track]');
      if (!track) return;
      this.lvAbort = new AbortController();
      const options = { signal: this.lvAbort.signal };
      const cards = [...track.querySelectorAll('.lv-story__review')];
      const buttons = [...this.querySelectorAll('[data-lv-review-step]')];
      const update = () => {
        buttons.forEach(button => {
          button.disabled = Number(button.dataset.lvReviewStep) < 0
            ? track.scrollLeft <= 2
            : track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        });
        const bounds = track.getBoundingClientRect();
        const visible = cards.map(card => card.getBoundingClientRect()).filter(rect =>
          Math.min(rect.right, bounds.right) - Math.max(rect.left, bounds.left) > Math.min(40, rect.width * .2));
        const height = Math.ceil(Math.max(0, ...visible.map(rect => rect.height))) + 1;
        if (visible.length && track.style.height !== height + 'px') track.style.height = height + 'px';
      };
      const schedule = () => {
        if (this.lvFrame) return;
        this.lvFrame = requestAnimationFrame(() => { this.lvFrame = null; update(); });
      };
      buttons.forEach(button => button.addEventListener('click', () => {
        const card = cards[0];
        const distance = (card ? card.getBoundingClientRect().width : track.clientWidth) + parseFloat(getComputedStyle(track).columnGap || 0);
        track.scrollBy({ left: Number(button.dataset.lvReviewStep) * distance, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }, options));
      track.addEventListener('scroll', schedule, { ...options, passive: true });
      this.lvResize = new ResizeObserver(schedule);
      this.lvResize.observe(track);
      cards.forEach(card => this.lvResize.observe(card));
      schedule();
    }
    disconnectedCallback() {
      this.lvAbort?.abort();
      this.lvResize?.disconnect();
      if (this.lvFrame) cancelAnimationFrame(this.lvFrame);
      this.lvAbort = null;
      this.lvResize = null;
      this.lvFrame = null;
    }
  });
}
